import { Component, OnInit } from '@angular/core'
import { FeaturedCardLayout } from 'src/app/shared/enums/featured-card-layout.enum'
import { Page } from 'src/app/shared/interfaces/page.interface'
import { FeaturedCard } from 'src/app/shared/interfaces/resources/featured-card.interface'
import { StripHtmlPipe } from 'src/app/shared/pipes/strip-html.pipe'
import { FeaturedCardService } from 'src/app/shared/services/featured-card.service'
import { MetaService } from 'src/app/shared/services/meta.service'
import { PageService } from 'src/app/shared/services/page-service/page.service'

@Component({
  selector: 'app-generative-ai-policies-and-initiatives',
  templateUrl: './generative-ai-policies-and-initiatives.component.html',
  styleUrls: ['./generative-ai-policies-and-initiatives.component.scss']
})
export class GenerativeAiPoliciesAndInitiativesComponent implements OnInit {
  featuredCards: FeaturedCard[]
  FeaturedCardLayout = FeaturedCardLayout
  loader = true

  constructor(
    private pageService: PageService,
    private featuredCardService: FeaturedCardService,
    private stripHtmlPipe: StripHtmlPipe,
    private metaService: MetaService
  ) {}

  ngOnInit() {
    this.pageService
      .show('generative-ai-initiatives-policies')
      .then((page: Page) => {
        if (page.featuredCardIds?.length) {
          this.featuredCardService
            .listByIds(page.featuredCardIds)
            .then((featuredCards: FeaturedCard[]) => {
              this.featuredCards = featuredCards
              this.loader = false
            })
        } else {
          this.featuredCards = []
          this.loader = false
        }

        this.metaService.setTags({
          title: page.metaTitle || page.title,
          description: this.stripHtmlPipe.transform(
            page.metaDescription || page.excerpt
          ),
          path: page.slug,
          absoluteOgImage: page.image
            ? page.image.socialCard
            : this.metaService.defaultMeta.absoluteOgImage
        })
      })
  }
}
